class AttaleeFooter extends HTMLElement {
  constructor() {
    super();
    this.mediaQuery = window.matchMedia('(max-width: 749px)');
    this.accordions = [...this.querySelectorAll('.attalee-footer__accordion')];
    this.onMediaChange = this.onMediaChange.bind(this);
  }

  connectedCallback() {
    this.onMediaChange();
    this.mediaQuery.addEventListener('change', this.onMediaChange);
  }

  disconnectedCallback() {
    this.mediaQuery.removeEventListener('change', this.onMediaChange);
  }

  onMediaChange() {
    if (this.mediaQuery.matches) {
      this.accordions.forEach((accordion, index) => {
        if (index === 0) {
          accordion.setAttribute('open', '');
        } else {
          accordion.removeAttribute('open');
        }
      });
      return;
    }

    this.accordions.forEach((accordion) => {
      accordion.setAttribute('open', '');
    });
  }
}

if (!customElements.get('attalee-footer')) {
  customElements.define('attalee-footer', AttaleeFooter);
}
